<template>
    <div>   

        <div id="loader" style="display: none; width:100%; text-align:center">
            <div style="margin:0 auto" class="lds-dual-ring"></div>
        </div>

        <div id="loaded" ref='uploadForm' class="box" encType="multipart/form-data">
            <div class="tabs">
                <ul>
                <li :class="{'is-active': page == 1}"><a v-on:click="page = 1">Opdracht verwijderen grafmonument</a></li>
                <li :class="{'is-active': page == 2}"><a v-on:click="page = 2">Bestelling tijdelijk tekstplaatje</a></li>
                </ul>
            </div>

            <div v-if="page == 1">
                <h2 class="subtitle">{{ config.name }} - Opdracht verwijderen grafmonument</h2>
                <div class="columns">
                    <div class="column is-half">
                        <div class="field">
                            <label class="label is-small">Uitvaartleider</label>
                            <div class="control">
                            <div class="select is-small">
                                <select name="uitvaartsleider_name" v-model="uitvaartsleider_name">
                                        <option v-for="uit in uitvaartleiders" :value="uit.id">{{ uit.first_name }} {{ uit.last_name }}</option>
                                </select>
                            </div>
                            <button @click="$router.push({ path: '/voegtoe' })" class="button is-link is-small">Voeg uitvaartleider toe</button>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label is-small">Naam overledene</label>
                            <div class="control">
                                <input class="input is-small" type="text" name="naam_overledene" v-model="naam_overledene">
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-half">
                                <div class="field">
                                    <label class="label is-small">Geboortedatum overledene</label>
                                    <div class="control">
                                        <input class="input is-small" type="date" name="geboortedatum" v-model="geboortedatum">
                                    </div>
                                </div>
                            </div>

                            <div class="column is-half">
                                <div class="field">
                                    <label class="label is-small">Overlijdensdatum overledene</label>
                                    <div class="control">
                                        <input class="input is-small" type="date" name="overlijdensdatum" v-model="overlijdensdatum">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="notification is-info is-light">
                            <div class="field">
                                <label class="label is-small">Naam eerste overledene</label>
                                <div class="control">
                                    <input class="input is-small" type="text" name="naam_eerste_overledene" v-model="naam_eerste_overledene">
                                </div>
                            </div>

                            <div class="field">
                                <label class="label is-small">Overlijdensdatum eerste overledene</label>
                                <div class="control">
                                    <input class="input is-small" type="date" name="datum_eerste_overledene" v-model="datum_eerste_overledene">
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-half">
                                <div class="field">
                                    <label class="label is-small">Begraafplaats</label>
                                    <div class="control">
                                        <input class="input is-small" type="text" name="begraafplaats" v-model="begraafplaats">
                                    </div>
                                </div>
                            </div>

                            <div class="column is-half">
                                <div class="field">
                                    <label class="label is-small">Grafnummer</label>
                                    <div class="control">
                                        <input class="input is-small" type="text" name="grafnummer" v-model="grafnummer">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-half">
                                <div class="field">
                                    <label class="label is-small">Datum uitvaart</label>
                                    <div class="control">
                                        <input class="input is-small" type="date" name="datum_uitvaart" v-model="datum_uitvaart">
                                    </div>
                                </div>
                            </div>

                            <div class="column is-half">
                                <div class="field">
                                    <label class="label is-small">Datum afhalen</label>
                                    <div class="control">
                                        <input class="input is-small" type="date" name="datum_afhalen" v-model="datum_afhalen">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label is-small">Is het een grafmonument van WeerstandGrafmonumenten?</label>
                            <div class="control">
                                <div class="select is-small" style="width:100%">
                                    <select name="steen_wrst" v-model="steen_wrst" style="width:100%">
                                        <option value="Ja">Ja</option>
                                        <option value="Nee">Nee</option>
                                        <option value="onbekend">Onbekend</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="column is-half">
                        <div class="notification is-info is-light">
                            <h2 class="subtitle"><i class="fas fa-clipboard-list"></i> Rechthebbende</h2>

                            <div class="field">
                                <label class="label is-small">Aanhef</label>
                                <div class="control">
                                    <input class="input is-small" type="text" name="naam_aanhef" v-model="naam_aanhef">
                                </div>
                            </div>

                            <div class="field">
                                <label class="label is-small">Voornaam</label>
                                <div class="control">
                                    <input class="input is-small" type="text" name="naam_rechtshebbende" v-model="naam_rechtshebbende">
                                </div>
                            </div>

                            <div class="field">
                                <label class="label is-small">Achternaam</label>
                                <div class="control">
                                    <input class="input is-small" type="text" name="naam_achternaam" v-model="naam_achternaam">
                                </div>
                            </div>

                            <div class="field">
                                <label class="label is-small">Straat + huisnummer</label>
                                <div class="control">
                                    <input class="input is-small" type="text" name="adres_rechtshebbende" v-model="adres_rechtshebbende">
                                </div>
                            </div>

                            <div class="field">
                                <label class="label is-small">Postcode</label>
                                <div class="control">
                                    <input class="input is-small" type="text" name="postcode_rechtshebbende" v-model="postcode_rechtshebbende">
                                </div>
                            </div>

                            <div class="field">
                                <label class="label is-small">Woonplaats</label>
                                <div class="control">
                                    <input class="input is-small" type="text" name="woonplaats_rechtshebbende" v-model="woonplaats_rechtshebbende">
                                </div>
                            </div>

                            <div class="field">
                                <label class="label is-small">Email</label>
                                <div class="control">
                                    <input class="input is-small" type="text" name="email_rechtshebbende" v-model="email_rechtshebbende">
                                </div>
                            </div>

                            <div class="field">
                                <label class="label is-small">Telefoonnummer</label>
                                <div class="control">
                                    <input class="input is-small" type="text" name="tel_rechtshebbende" v-model="tel_rechtshebbende">
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label is-small">Rouwkaart (Uploaden t.b.v tijdelijk naamplaatje)</label>
                            <div class="control">
                                <div id="file-js-example" class="file is-info has-name is-fullwidth">
                                    <label class="file-label">
                                    <input class="file-input" id="fileUpload" type="file" @change="uploadImage($event)" name="rouwkaart">
                                    <span class="file-cta">
                                        <span class="file-icon">
                                        <i class="fas fa-upload"></i>
                                        </span>
                                        <span class="file-label">
                                        Kies een bestand...
                                        </span>
                                    </span>
                                    <span class="file-name">
                                        {{bestandNaam}}
                                    </span>
                                    </label>
                                </div>
                            </div>
                            <br />
                            <div class="field">
                                <label class="label is-small">Opmerkingen</label>
                                <div class="control">
                                    <textarea class="textarea is-small" name="opmerkingen" v-model="opmerkingen"></textarea>
                                </div>
                            </div>
                        </div>

                        <br />

                        <div class="field is-grouped">
                            <div class="control">
                                <button @click="Verstuur" class="button is-link is-large">Verstuur</button>
                            </div>
                        </div>

                        <div class="notification is-danger" v-if="errorShow">
                            <button class="delete" @click="HideMessage"></button>
                            <b>Er is een fout opgetreden!</b><br />
                            {{errorMessage}}
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="page == 2">
                <h2 class="subtitle">{{ config.name }} - Bestelling tijdelijk tekstplaatje</h2>
                <div class="columns">
                    <div class="column is-half">
                        <div class="field">
                            <label class="label is-small">Uitvaartleider</label>
                            <div class="control">
                            <div class="select is-small">
                                <select name="uitvaartsleider_name" v-model="uitvaartsleider_name">
                                        <option v-for="uit in uitvaartleiders" :value="uit.id">{{ uit.first_name }} {{ uit.last_name }}</option>
                                </select>
                            </div>
                            <button @click="$router.push({ path: '/voegtoe' })" class="button is-link is-small">Voeg uitvaartleider toe</button>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label is-small">Naam overledene</label>
                            <div class="control">
                                <input class="input is-small" type="text" name="naam_overledene" v-model="naam_overledene">
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-half">
                                <div class="field">
                                    <label class="label is-small">Geboortedatum overledene</label>
                                    <div class="control">
                                        <input class="input is-small" type="date" name="geboortedatum" v-model="geboortedatum">
                                    </div>
                                </div>
                            </div>

                            <div class="column is-half">
                                <div class="field">
                                    <label class="label is-small">Overlijdensdatum overledene</label>
                                    <div class="control">
                                        <input class="input is-small" type="date" name="overlijdensdatum" v-model="overlijdensdatum">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="notification is-info is-light">
                            <div class="field">
                                <label class="label is-small">Naam eerste overledene</label>
                                <div class="control">
                                    <input class="input is-small" type="text" name="naam_eerste_overledene" v-model="naam_eerste_overledene">
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column is-half">
                                    <div class="field">
                                        <label class="label is-small">Geboortedatum eerste overledene</label>
                                        <div class="control">
                                            <input class="input is-small" type="date" name="geboortedatum_eerste_overledene" v-model="geboortedatum_eerste_overledene">
                                        </div>
                                    </div>
                                </div>

                                <div class="column is-half">
                                    <div class="field">
                                        <label class="label is-small">Overlijdensdatum eerste overledene</label>
                                        <div class="control">
                                            <input class="input is-small" type="date" name="datum_eerste_overledene" v-model="datum_eerste_overledene">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label is-small">Grafnummer</label>
                            <div class="control">
                                <input class="input is-small" type="text" name="grafnummer" v-model="grafnummer">
                            </div>
                        </div>

                        <div class="field">
                            <label class="label is-small">Rouwkaart (Uploaden t.b.v tijdelijk naamplaatje)</label>
                            <div class="control">
                                <div id="file-js-example" class="file is-info has-name is-fullwidth">
                                    <label class="file-label">
                                    <input class="file-input" id="fileUpload" type="file" @change="uploadImage($event)" name="rouwkaart">
                                    <span class="file-cta">
                                        <span class="file-icon">
                                        <i class="fas fa-upload"></i>
                                        </span>
                                        <span class="file-label">
                                        Kies een bestand...
                                        </span>
                                    </span>
                                    <span class="file-name">
                                        {{bestandNaam}}
                                    </span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label is-small">Opmerkingen</label>
                            <div class="control">
                                <textarea class="textarea is-small" name="opmerkingen" v-model="opmerkingen"></textarea>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label is-small">Geselecteerde tekstplaatje</label>
                            <div class="control">
                                <img class="box" :src="assetImageUrl(tekstplaatjes[selectedText])" />
                            </div>
                        </div>

                    </div>
                    <div class="column is-half">
                        <div v-for="index in 5" :key="index">
                            <div class="columns">

                                <div class="column is-one-quarter">
                                    <div v-on:click="SelectText(index*4-4)" :class="{'card': true, 'jb-card-img': index*4-4 != selectedText, 'jb-card-img-selected': index*4-4 == selectedText}">
                                        <div class="card-image">
                                            <figure class="image is-4by3">
                                                <img :src="assetImageUrl(tekstplaatjes[index * 4 - 4])" />
                                            </figure>
                                        </div>
                                    </div>
                                </div>

                                <div class="column is-one-quarter">
                                    <div v-on:click="SelectText(index*4-3)" :class="{'card': true, 'jb-card-img': index*4-3 != selectedText, 'jb-card-img-selected': index*4-3 == selectedText}">
                                        <div class="card-image">
                                            <figure class="image is-4by3">
                                                <img :src="assetImageUrl(tekstplaatjes[index * 4 - 3])" />
                                            </figure>
                                        </div>
                                    </div>
                                </div>

                                <div class="column is-one-quarter">
                                    <div v-on:click="SelectText(index*4-2)" :class="{'card': true, 'jb-card-img': index*4-2 != selectedText, 'jb-card-img-selected': index*4-2 == selectedText}">
                                        <div class="card-image">
                                            <figure class="image is-4by3">
                                                <img :src="assetImageUrl(tekstplaatjes[index * 4 - 2])" />
                                            </figure>
                                        </div>
                                    </div>
                                </div>

                                <div class="column is-one-quarter">
                                    <div v-on:click="SelectText(index*4-1)" :class="{'card': true, 'jb-card-img': index*4-1 != selectedText, 'jb-card-img-selected': index*4-1 == selectedText}">
                                        <div class="card-image">
                                            <figure class="image is-4by3">
                                                <img :src="assetImageUrl(tekstplaatjes[index * 4 - 1])" />
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="field is-grouped">
                            <div class="control">
                                <button @click="VerstuurTekst" class="button is-link is-large">Verstuur</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Formulier',
  data () {
    return {
        tekstplaatjes: ['Kader', 'Biddende-handen', 'Tak', 'Orchidee', 'Bloem', 'Hart', 'Duif', 'Bos', 'Zeezicht', 'Zee', 'Kotter', 'Oud-Urk', 'Boer', 'Aren', 'Beertje-blauw', 'Beertje-hart', 'Mozes', 'Goede-Herder', 'Trap-naar-hemel', 'Laat-de-kinderen'],
        selectedText: 0,
        page: 1,
        uitvaartleiders: [],
        uitvaartsleider_name: "",
        naam_overledene: "",
        geboortedatum: "",
        overlijdensdatum: "",
        naam_eerste_overledene: "",
        datum_eerste_overledene: "",
        geboortedatum_eerste_overledene: "",
        begraafplaats: "",
        grafnummer: "",
        naam_aanhef: "",
        naam_rechtshebbende: "",
        naam_achternaam: "",
        adres_rechtshebbende: "",
        woonplaats_rechtshebbende: "",
        email_rechtshebbende: "",
        postcode_rechtshebbende: "",
        tel_rechtshebbende: "",
        datum_uitvaart: "",
        datum_afhalen: "",
        steen_wrst: "",
        image: '',
        previewImage:null,
        errorMessage: "",
        errorShow: false,
        bestandNaam: "Geen bestand geselecteerd",
        hoverMode: false,
        opmerkingen: "",
    }
  },

    methods: {
        assetImageUrl(imageName) {
            return `${window.location.origin}/${imageName}.jpg`
        },
        VerstuurTekst() {
            document.getElementById('loader').style.display = 'block'
            document.getElementById('loaded').style.display = 'none'

            var form = {
                uitvaartsleider_name: this.uitvaartsleider_name,
                naam_overledene: this.naam_overledene,
                geboortedatum: this.geboortedatum,
                overlijdensdatum: this.overlijdensdatum,
                grafnummer: this.grafnummer,
                uitvaart_bedrijf_name: this.config.name,
                naam_eerste_overledene: this.naam_eerste_overledene,
                datum_eerste_overledene: this.datum_eerste_overledene,
                geboortedatum_eerste_overledene: this.geboortedatum_eerste_overledene,
                image_name: this.bestandNaam,
                selectedText: this.selectedText,
                arrayText: this.tekstplaatjes,
                opmerkingen: this.opmerkingen
            }

            this.axios.post('https://backend.weerstandgrafmonumenten.nl/api/takeForm/text-picture', {form: form, previewImage:this.previewImage}).then(response => {
                
                document.getElementById('loader').style.display = 'none'
                document.getElementById('loaded').style.display = 'block'

                if (response.data) {
                    this.errorShow = true
                    this.errorMessage = response.data
                } else {
                    this.$router.push({ path: '/success' })
                }
            }).catch(err => {
                this.errorShow = true
                this.errorMessage = err.response

                document.getElementById('loader').style.display = 'none'
                document.getElementById('loaded').style.display = 'block'
            })
        },
        SelectText(i) {
            console.log(i)
            this.selectedText = i
        },
        DragOver(e) {
            event.preventDefault();
            var dt = e.originalEvent.dataTransfer;
            if (dt.types && (dt.types.indexOf ? dt.types.indexOf('Files') != -1 : dt.types.contains('Files'))) {
                this.hoverMode = true
            }
        },

        DragLeave(e) {
            this.hoverMode = false
        },

        Drop(e) {
            event.preventDefault();
            $('input').file = e.originalEvent.dataTransfer.files[0]
            this.hoverMode = false
            this.bestandNaam = e.originalEvent.dataTransfer.files[0].name

            const image = e.originalEvent.dataTransfer.files[0]
            this.bestandNaam = image.name
            const reader = new FileReader()
            reader.readAsDataURL(image)
            reader.onload = e =>{
                this.previewImage = e.target.result
            }
        },

        HideMessage() {
            this.errorShow = false
            this.errorMessage = ""
        },

        Verstuur() {
            document.getElementById('loader').style.display = 'block'
            document.getElementById('loaded').style.display = 'none'

            var form = {
                uitvaartsleider_name: this.uitvaartsleider_name,
                naam_overledene: this.naam_overledene,
                geboortedatum: this.geboortedatum,
                overlijdensdatum: this.overlijdensdatum,
                naam_eerste_overledene: this.naam_eerste_overledene,
                datum_eerste_overledene: this.datum_eerste_overledene,
                begraafplaats: this.begraafplaats,
                grafnummer: this.grafnummer,
                naam_rechtshebbende: this.naam_rechtshebbende,
                naam_aanhef: this.naam_aanhef,
                naam_achternaam: this.naam_achternaam,
                adres_rechtshebbende: this.adres_rechtshebbende,
                woonplaats_rechtshebbende: this.woonplaats_rechtshebbende,
                email_rechtshebbende: this.email_rechtshebbende,
                postcode_rechtshebbende: this.postcode_rechtshebbende,
                tel_rechtshebbende: this.tel_rechtshebbende,
                datum_uitvaart: this.datum_uitvaart,
                datum_afhalen: this.datum_afhalen,
                steen_wrst: this.steen_wrst,
                uitvaart_bedrijf_name: this.config.name,
                image_name: this.bestandNaam,
                opmerkingen: this.opmerkingen
            }

            this.axios.post('https://backend.weerstandgrafmonumenten.nl/api/takeForm/deduct', {form: form, previewImage:this.previewImage}).then(response => {
                
                document.getElementById('loader').style.display = 'none'
                document.getElementById('loaded').style.display = 'block'
                
                if (response.data) {
                    this.errorShow = true
                    this.errorMessage = response.data
                } else {
                    this.$router.push({ path: '/success' })
                }
            }).catch(err => {
                this.errorShow = true
                this.errorMessage = err.response

                document.getElementById('loader').style.display = 'none'
                document.getElementById('loaded').style.display = 'block'
            })
        },
        uploadImage(e) {
            const image = e.target.files[0]
            this.bestandNaam = image.name
            const reader = new FileReader()
            reader.readAsDataURL(image)
            reader.onload = e =>{
                this.previewImage = e.target.result
            }
        },
    },

  mounted() {
  	this.axios.get("https://backend.weerstandgrafmonumenten.nl/api/contacts/get/" + this.config.id).then(response => {
        this.uitvaartleiders = response.data
        this.uitvaartsleider_name = this.uitvaartleiders[0].id
    })

    $(document).on('drop', (event) => this.Drop(event))
    $(document).on('dragover', (event) => this.DragOver(event))
    $(document).on('dragleave', (event) => this.DragLeave(event))
  },
}
</script>

<style>
.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Formulier.vue